<template>
  <div>
    <key-type-select
      v-model="keyType"
      class="mb-3"
      :allow-cloud="!!dialog.dialogData.diiaRequest"></key-type-select>
    <sign-local
      v-if="['file', 'media'].includes(keyType)"
      :keyType="keyType"
      @cancel="dialog.close()"></sign-local>
    <sign-cloud
      v-if="keyType === 'cloud'"
      @cancel="dialog.close()"></sign-cloud>
  </div>
</template>

<script lang="ts">
import SignLocal from './sign-local/SignLocal.vue'
import SignCloud from './sign-cloud/SignCloud.vue'
import KeyTypeSelect from './KeyTypeSelect.vue'
import { computed, PropType, ref, provide } from 'vue'
import { getErrorMessages } from 'best-modules/utils'
import { Dialog } from '@/dialog'
import { AuthorizationKey, dialogKey, fileToSignKey } from './injectionKeys'
import { getFile } from '@/utils/helpers'
import { KeyType, FileToSign, SignDocumentDialogData } from './types'

export default {
  name: 'SignDocument',
  components: {
    SignLocal,
    SignCloud,
    KeyTypeSelect,
  },
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: { getErrorMessages },
  setup(props) {
    const keyType = ref<KeyType>('file')
    const Authorization = computed<string | null>(() => {
      if (props.dialog.dialogData.authToken) {
        return `Bearer ${props.dialog.dialogData.authToken}`
      } else {
        return null
      }
    })
    const fileToSign = ref<FileToSign[]>([])

    for (const document of props.dialog.dialogData
      .documents as SignDocumentDialogData['documents']) {
      getFile({
        path: document.document.path,
        type: 'blob',
        token: Authorization.value,
      }).then(async (blob: Blob) => {
        fileToSign.value.push({
          file: new Uint8Array(await blob.arrayBuffer()),
          document: document.document,
          fileName: document.document.name,
          uploadFilesParams: document.uploadFilesParams,
          meta: document.meta,
        })
      })
    }

    provide(dialogKey, props.dialog)
    provide(AuthorizationKey, Authorization)
    provide(fileToSignKey, fileToSign)

    return {
      keyType,
    }
  },
}
</script>

<style lang="scss" scoped>
.how-work {
  background: #514ef30a;
  padding: 12px 20px;
  border-radius: 8px;
  border-left: 4px solid #7e92a2;
  &-container {
    gap: 15px;
    display: inline-grid;
  }
}
</style>
